import React from 'react';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import ClipItem from 'components/HomeClip/ClipItem/ClipItem';
import { isAudio } from 'helpers/AppHelper';
import './ClipList.scss';


const ClipList = observer(
    class ClipList extends React.Component {

        render() {
            return (<div className={isAudio() ? "ClipList" : ""}>
                {this.props.items.map((item, i) => <ClipItem key={`cliplist_${i}`} clip={item} isOdd={i % 2 > 0} />)}
            </div>)
        }
    }
);


export default Flow.injectFlow(ClipList);